import styled from 'styled-components'

import type {
  StyledClearIndicatorProps,
  StyledDropdownIndicatorProps,
} from './types'

export const DropdownIndicatorContainer = styled.div<StyledDropdownIndicatorProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: ${({ theme }) => theme.colors.sapphireDark};
  cursor: pointer;
  transform: ${(props) => `rotate(${props.isOpen ? '0' : '-180deg'})`};
  transition: transform 350ms ease;
  opacity: ${({ isDisabled }) => (isDisabled ? '0.2' : '1')};
`

export const MultiValueRemoveContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.blueAura};
  width: 8px;
  height: 8px;
  cursor: pointer;
`

export const ClearContainer = styled.div<StyledClearIndicatorProps>`
  margin-right: ${({ $hasDropdown }) => ($hasDropdown ? '0px' : '8px')};
  display: flex;
  align-items: flex-end;
  justify-content: end;
  color: ${({ theme }) => theme.colors.fibonacciBlue};
  width: 18px;
  height: 18px;
  cursor: pointer;
`
